<template>
  <sup>
    <v-icon small style="color:#3F9DF5;caret-color:#3F9DF5;text-shadow:none;">mdi-check-decagram</v-icon>
  </sup>
</template>

<script>
export default {
  name: "VerifiedSign",
};
</script>